import { render, staticRenderFns } from "./JourneysList.vue?vue&type=template&id=69fa5eb5&lang=pug&"
import script from "./JourneysList.vue?vue&type=script&lang=js&"
export * from "./JourneysList.vue?vue&type=script&lang=js&"
import style0 from "./JourneysList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports